import { gql } from '@apollo/client';

const VisitAppointmentRow = gql`
    fragment VisitAppointmentRow on ClinicianAppointment {
        id
        clinician {
            ...ClinicianChipFragment
        }
        services {
            id
            name
        }
        modality
    }
`;

const VisitRequestAppointmentRow = gql`
    fragment VisitRequestAppointmentRow on VisitRequestAppointment {
        id
        clinician {
            ...ClinicianChipFragment
        }
        services {
            id
            name
        }
    }
`;

export const VisitRequestTableRow = gql`
    fragment VisitRequestTableRow on VisitRequest {
        __typename
        id
        state
        priority
        workflowStep
        tentativeDate
        fulfillmentWindow {
            startDate
            endDate
        }
        patient {
            id
            fullName
        }
        address {
            ...BasicAddressWithCoordinatesFragment
        }
        disciplines {
            ...DisciplineChipFragment
        }
        appointments {
            ...VisitRequestAppointmentRow
        }
        order {
            numActiveOccurrences
            fulfillmentWindow {
                startDate
            }
            ...OrderChipFragment
        }
        warnings {
            message
        }
    }

    ${VisitRequestAppointmentRow}
`;

export const VisitTableRow = gql`
    fragment VisitTableRow on Visit {
        __typename
        id
        state
        priority
        patient {
            id
            fullName
        }
        startDatetime
        effectiveDate
        tentativeDate
        timezone
        fulfillmentWindow {
            startDatetime
            endDatetime
            asDateWindow {
                startDate
                endDate
            }
        }
        address {
            ...BasicAddressWithCoordinatesFragment
        }
        disciplines {
            ...DisciplineChipFragment
        }
        appointments: clinicianAppointments {
            ...VisitAppointmentRow
        }
        order {
            numActiveOccurrences
            ...OrderChipFragment
        }
        warnings {
            message
        }
    }

    ${VisitAppointmentRow}
`;
